import type { HereAndNowTab } from "@lib/logic";

import { FacilityDetails } from "./details/facility/FacilityDetails";
import { RoomDetails } from "./details/room/RoomDetails";
import { WorkspaceDetails } from "./details/workspace/WorkspaceDetails";
import { Facilities } from "./facilities/Facilities";
import { Rooms } from "./rooms/Rooms";
import { HaN } from "./shell/HaN";
import { Workspaces } from "./workspaces/Workspaces";

export const HereAndNowRevamp = ({ tab }: { tab: HereAndNowTab }) => {
  return (
    <HaN.Page tab={tab}>
      <HaN.Header />
      <HaN.CalendarSyncTile />

      <HaN.TabsBar>
        <HaN.Tabs />
      </HaN.TabsBar>

      <HaN.FilterBar>
        <Rooms.Filters />
        <Workspaces.Filters />
        <Facilities.Filters />
      </HaN.FilterBar>

      <HaN.List>
        <Rooms.List />
        <Workspaces.List />
        <Facilities.List />
      </HaN.List>

      <HaN.MapStage>
        <Rooms.Map />
        <Workspaces.Map />
        <Facilities.Map />
        <HaN.FloorSelector />
      </HaN.MapStage>

      <HaN.Carousel>
        <Rooms.Carousel />
        <Workspaces.Carousel />
        <Facilities.Carousel />
      </HaN.Carousel>

      <HaN.Details>
        <RoomDetails />
        <WorkspaceDetails />
        <FacilityDetails />
      </HaN.Details>
    </HaN.Page>
  );
};
